import type { FaireProductEntity } from "../../entity_types/product";

export const p_rm2wvgm2j4: FaireProductEntity = {
  token: "p_rm2wvgm2j4",
  type: "product",
  name: "Nutcracker 3pc Mini PRO Holiday Set",
  brandToken: "b_51514ef0",
  brandName: "The Original MakeUp Eraser",
  imageUrl:
    "https://cdn.faire.com/fastly/2d93299155cf566ce2755ed02e3aa3c471696e01f42d4b278506080a578712eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/712df07ad97115f9c14cb99ae349d2288816a40f3b5092736a828f51c3b81f1e.jpeg",
    "https://cdn.faire.com/fastly/66470a1113244fb8362aaf76396f20d44d4541732444268eb947f4cd89964a1b.jpeg",
    "https://cdn.faire.com/fastly/f78dce94be811c63942c45ed8ab76b1283dacdaba40bc1943c7012b69dd55dea.jpeg",
    "https://cdn.faire.com/fastly/dafd9de8158a8952f9b5c02cc16bfd851b19464a0d923618198f814dad53f7a8.jpeg",
    "https://cdn.faire.com/fastly/3b08d852dc4121468334e94f856fb0ab8752eb43f559bf3dfe946bbf538ef1ef.png",
    "https://cdn.faire.com/fastly/fe811e46c5cc92daf6aafdd77395e908dd629d799ffe380b1730a5e0c0123b02.png",
    "https://cdn.faire.com/fastly/962b2eeb2177903a361c16fc55f51a993641f894de2edda8c1fc5af1ff88563f.png",
    "https://cdn.faire.com/fastly/f47f4ac252c62b29c58bfdb0fd2143a1a46e21203452208a9df615b47cc34d7b.png",
  ],
  priceDollars: 15,
  description:
    "Includes (3) Mini PRO MakeUp Erasers individually boxed in a giftable box, 8in x 4in.\n\nThis giftable value set has an SRP: $30 & Product Value of $36\n\nErase all makeup with JUST WATER™ including waterproof. Our patented, water-activated, cloud-soft fibers gently & easily remove all makeup & sunscreen from pores. 2 in 1 benefit: one side erases makeup & one side exfoliates skin.\n\n\n\n\n✓ Dermatologist Recommended\n\n\n✓ SmartErase™ Technology\n\n\n✓ Reusable & machine washable\n\n✓ Great for heavy makeup\n\n\n\n\nThe Original MakeUp Eraser® is non-irritating and non-drying, making it perfect for sensitive skin. It's non-comedogenic, safe for lash extensions, & entirely oil-free for a fresh, comfortable experience.\n\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:27.386Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
